import { api } from '@/utils/axios';

export const subscribe = async (
  planId: number,
  interval: 'monthly' | 'yearly',
  quantity?: number,
) => {
  const response = await api.post('/stripe/subscribe', {
    feature_id: planId,
    interval,
    quantity,
  });
  return response.data;
};

export const assignSeat = async (subscriptionId: number, userId: number) => {
  const response = await api.post('/stripe/subscriptions/seats/assign', {
    subscription_id: subscriptionId,
    user_id: userId,
  });
  return response.data;
};

export const removeSeat = async (subscriptionId: number, userId: number) => {
  const response = await api.post('/stripe/subscriptions/seats/remove', {
    subscription_id: subscriptionId,
    user_id: userId,
  });
  return response.data;
};
